import { atom, useAtom } from "jotai";
import { type Address } from "viem";

import { useMirrorAccount } from "#/store/app/devMode/mirrorAccount";

export const eoaAtom = atom<Address>();

export const useEoa = () => {
  const { mirrorAccount } = useMirrorAccount();

  const [eoa, setEoa] = useAtom(eoaAtom);

  return {
    eoa: mirrorAccount || eoa,
    isEoaConnected: Boolean(mirrorAccount || eoa),
    setEoa,
  };
};
